var map = {
	"./50plus.svg": [
		53367,
		3367
	],
	"./affairs.svg": [
		3091,
		3091
	],
	"./android.svg": [
		54672,
		4672
	],
	"./apple.svg": [
		9239,
		9239
	],
	"./arrow-down.svg": [
		87554,
		7554
	],
	"./arrow-right-v2.svg": [
		48485,
		8485
	],
	"./arrow-right.svg": [
		48837,
		8837
	],
	"./arrow-up.svg": [
		6881,
		6881
	],
	"./audio.svg": [
		67017,
		7017
	],
	"./bbc.svg": [
		98832,
		9857
	],
	"./budget.svg": [
		79069,
		9069
	],
	"./bulb.svg": [
		42841,
		2841
	],
	"./bulletpoint-heart.svg": [
		59210,
		9210
	],
	"./calendar.svg": [
		32690,
		2690
	],
	"./cam.svg": [
		37604,
		7604
	],
	"./chat-bot.svg": [
		67330,
		3887
	],
	"./chat.svg": [
		17283,
		7283
	],
	"./checkmark.svg": [
		63817,
		3817
	],
	"./chevron-down.svg": [
		87560,
		603
	],
	"./circle-loader.svg": [
		9374,
		9374
	],
	"./circledX.svg": [
		56160,
		6160
	],
	"./clipboard.svg": [
		66979,
		6979
	],
	"./compado-horizontal.svg": [
		59711,
		9711
	],
	"./compado.svg": [
		89118,
		9118
	],
	"./copy.svg": [
		20110,
		110
	],
	"./crossmark.svg": [
		47633,
		7633
	],
	"./diabetics.svg": [
		43664,
		3664
	],
	"./discretion.svg": [
		22537,
		2537
	],
	"./down.svg": [
		88557,
		8557
	],
	"./download-globe.svg": [
		88989,
		8989
	],
	"./download.svg": [
		63632,
		3632
	],
	"./educated.svg": [
		97322,
		7322
	],
	"./flings.svg": [
		46435,
		6435
	],
	"./free.svg": [
		9787,
		9787
	],
	"./gluten-free.svg": [
		63480,
		3480
	],
	"./hand-shake.svg": [
		37670,
		7670
	],
	"./hbo.svg": [
		17009,
		7009
	],
	"./hulu.svg": [
		66516,
		6516
	],
	"./keto.svg": [
		75733,
		5733
	],
	"./left.svg": [
		76034,
		6034
	],
	"./live_talk.svg": [
		16731,
		6731
	],
	"./location.svg": [
		77534,
		7534
	],
	"./mealkits.svg": [
		64973,
		4973
	],
	"./message.svg": [
		37210,
		7210
	],
	"./mobile.svg": [
		81244,
		1244
	],
	"./nav-right.svg": [
		25973,
		5973
	],
	"./netflix.svg": [
		87877,
		7877
	],
	"./organic.svg": [
		78544,
		8544
	],
	"./paleo.svg": [
		201,
		201
	],
	"./paste.svg": [
		22,
		22
	],
	"./photos.svg": [
		71657,
		1657
	],
	"./play.svg": [
		58057,
		8057
	],
	"./preparedmeals.svg": [
		60778,
		778
	],
	"./rating-icons/fork-knife.svg": [
		69136,
		9136
	],
	"./rating-icons/fork.svg": [
		3481,
		3481
	],
	"./rating-icons/heart.svg": [
		65924,
		5924
	],
	"./rating-icons/spoon.svg": [
		9667,
		9667
	],
	"./rating-icons/star.svg": [
		26427,
		6427
	],
	"./right.svg": [
		89898,
		9898
	],
	"./safe.svg": [
		17805,
		7805
	],
	"./scientific.svg": [
		54503,
		4503
	],
	"./senior.svg": [
		82427,
		2427
	],
	"./text.svg": [
		22937,
		2937
	],
	"./upload.svg": [
		55792,
		5792
	],
	"./utorrent.svg": [
		49086,
		9086
	],
	"./vegetarian.svg": [
		57560,
		7560
	],
	"./video.svg": [
		79003,
		9003
	],
	"./weight-loss.svg": [
		19879,
		9879
	],
	"./windows.svg": [
		77105,
		7105
	],
	"./wine.svg": [
		49161,
		9161
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 84023;
module.exports = webpackAsyncContext;